<script setup>
import UserSearch from '@/components/admin/featureFlags/partials/UserSearch.vue';
import FeatureFlagsList from '@/components/admin/featureFlags/partials/FeatureFlagsList.vue';
import {useFeatureFlags} from '@/composables/admin/useFeatureFlags';

const { user } = useFeatureFlags();
</script>

<template>
  <div class="tw-m-auto tw-max-w-default-container">
    <div class="tw-flex tw-flex-col tw-gap-8">
      <div class="tw-flex tw-justify-between tw-items-center">
        <h1 class="tw-text-4.5xl tw-text-font-primary tw-font-bold tw-font-sans">
          Feature Flags
        </h1>
      </div>

      <p class="tw-text-font-secondary tw-text-base">
        Toggle feature overrides for individual users. Changes take effect immediately without requiring a deployment.
        Use this instead of running <code class="tw-font-mono tw-text-sm tw-bg-gray-100 tw-px-1 tw-rounded">php artisan features:override</code>.
      </p>

      <div class="tw-bg-white tw-rounded-lg tw-p-8">
        <UserSearch />
      </div>

      <div
        v-if="user"
        class="tw-bg-white tw-rounded-lg tw-p-8"
      >
        <FeatureFlagsList />
      </div>
    </div>
  </div>
</template>
